var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 72.977,
  height: 72.977,
  viewBox: "0 0 72.977 72.977"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-704 -96)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.489,0A36.489,36.489,0,1,0,72.977,36.489,36.529,36.529,0,0,0,36.489,0Zm0,0",
  transform: "translate(704 96)",
  fill: "#00b50e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.167,170.519,156.4,190.284a3.038,3.038,0,0,1-4.3,0L142.22,180.4a3.04,3.04,0,0,1,4.3-4.3l7.732,7.732,17.615-17.615a3.04,3.04,0,0,1,4.3,4.3Zm0,0",
  transform: "translate(582.816 -45.763)",
  fill: "#fafafa"
}))));
export default __webpack_public_path__ + "static/media/sucees.2fb83903.svg";
export { SvgComponent as ReactComponent };